import { jwtDecode } from 'jwt-decode'

export const getCookieByName = (name: string) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)

    if (parts.length > 1) {
        return parts.pop()?.split(';')?.shift() || ''
    }

    return ''
}

export const decodeJwtToken = (token: string) => {
    let decodedToken: any
    try {
        decodedToken = jwtDecode(token)
    } catch {
        decodedToken = {}
    }

    const extra =
        typeof decodedToken.extra === 'string'
            ? JSON.parse(decodedToken.extra)
            : { is_chargemap_boost: false }
    const isBoostUser = extra.is_chargemap_boost

    return [isBoostUser]
}
